import { Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'app-waitingplaceholder',
  imports: [],
  templateUrl: './waitingplaceholder.component.html',
  styleUrl: './waitingplaceholder.component.scss'
})
export class WaitingplaceholderComponent {
  @Input() title: string = "Generating solutions..."
  @Input() message: string = "Please wait, generating content..."
  @Input() log: string[] = []
  previousLogLength = 0
  @ViewChild('progressLogWrapper') progressLogWrapper!: ElementRef;

  ngAfterViewChecked() {
    if (this.log.length !== this.previousLogLength) { // scrolls to bottom of progress log when new message is added
      this.scrollToBottom();
      this.previousLogLength = this.log.length;
    }
  }

  private scrollToBottom() {
    try {
      this.progressLogWrapper.nativeElement.scrollTop =
        this.progressLogWrapper.nativeElement.scrollHeight;
    } catch (err) {}
  }

}
